// extracted by mini-css-extract-plugin
export var actions = "_dp-g";
export var benefitCard = "_dp-b";
export var benefitIcon = "_dp-d";
export var benefitLabel = "_dp-f";
export var benefits = "_dp-a";
export var benefitsSection = "_dp-8";
export var bodyText = "_dp-7";
export var closeButton = "_dp-2";
export var content = "_dp-3";
export var eyebrow = "_dp-4";
export var heading = "_dp-5";
export var image = "_dp-i";
export var imagePanel = "_dp-h";
export var modal = "_dp-0";
export var offerCard = "_dp-c";
export var offerIcon = "_dp-e";
export var sectionLabel = "_dp-9";
export var shell = "_dp-1";
export var title = "_dp-6";